import { useTranslation } from 'react-i18next'

import {
  getEntityTabAttributeLabel,
  isEntityTabAttributeGroupValue,
} from '../EntityTabAttributes.utils'
import { EntityTabAttributesEntry } from '../EntityTabAttributesEntry'

import * as styles from './EntityTabAttributesGroup.module.css'

function EntityTabAttributesGroup({ label, value }) {
  const { i18n, t } = useTranslation()

  return (
    <div className={styles.group}>
      <h3 className={styles.groupTitle}>
        {getEntityTabAttributeLabel({ i18n, label, t })}
      </h3>
      <div className={styles.groupContent}>
        {Object.entries(value).map(([childLabel, childValue]) =>
          isEntityTabAttributeGroupValue(childValue) ? (
            <EntityTabAttributesGroup
              key={childLabel}
              label={childLabel}
              value={childValue}
            />
          ) : (
            <EntityTabAttributesEntry
              key={childLabel}
              label={childLabel}
              value={childValue}
            />
          )
        )}
      </div>
    </div>
  )
}

export default EntityTabAttributesGroup
